<mat-icon (click)="close()" style="cursor: pointer">close</mat-icon>
<mat-dialog-content>
  <iframe class="login-iframe" src="" style="width: 100% ; height: 100%"></iframe>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="mat-raised-button" (click)="close()">Close</button>
</mat-dialog-actions>

